import "./UpcomingMilestonesTaskPanel.css";

import { ReactElement } from "react";

import { SearchWorkflowTasksResponse } from "../../service/query";
import { Column, CursorDataGrid, FlyoutPanel, Row } from "../../widget";
import { useUpcomingMilestonesTaskPanel } from "./useUpcomingMilestonesTaskPanel";

interface UpcomingMilestonesTaskPanelProps {
  projectUuid?: string;
  groupUuid?: string;
  workflowUuid?: string;
  isDashboard?: boolean;
  show: boolean;
  onClose: () => void;
  setSelectedPanelTask: (task: SearchWorkflowTasksResponse["results"][0] | undefined) => void;
  setShowWorkflowTaskPanel: (show: boolean) => void;
  refreshTasks: boolean;
}

export const UpcomingMilestonesTaskPanel = ({
  projectUuid,
  groupUuid,
  workflowUuid,
  isDashboard = false,
  show,
  onClose,
  setSelectedPanelTask,
  setShowWorkflowTaskPanel,
  refreshTasks,
}: UpcomingMilestonesTaskPanelProps): JSX.Element => {
  const { columns, defaultSortingCriteria, dataIsLoading, onChange } = useUpcomingMilestonesTaskPanel({
    projectUuid,
    groupUuid,
    workflowUuid,
    isDashboard,
    setSelectedPanelTask,
    setShowWorkflowTaskPanel,
  });

  const content = (): ReactElement => (
    <div className="UpcomingMilestonesTaskPanelContent">
      <div className="UpcomingMilestonesTaskTable">
        <Row>
          <Column span={12}>
            <CursorDataGrid
              columns={columns}
              clientSide={false}
              filterable
              onChange={onChange}
              sortable
              data={[]}
              refresh={refreshTasks}
              dataIsLoading={dataIsLoading}
              defaultSortingCriteria={defaultSortingCriteria}
              noDataMessage="No upcoming milestones to display"
            />
          </Column>
        </Row>
      </div>
    </div>
  );

  return (
    <FlyoutPanel
      show={show}
      onClose={onClose}
      size="Large"
      header="Upcoming milestones"
      contentChildren={content()}
      buttonsChildren={undefined}
    />
  );
};
